export default __webpack_public_path__ + "static/Photo 1-4c0496adbda332ac57b622da9d31524c.jpg";